/**
 * MenuItem class.
 *
 * @ngInject
 */
export default class MenuItem {
  /**
   * Constructor of the class
   */
  constructor(item) {
    this.title = item.title;
    this.state = item.state;
    this.tooltip = item.tooltip;
    this.permissions = item.permissions;
    this.hideLogged = Boolean(item.hideLogged);
    this.params = item.params || {};
    this.items = (item.items || []).map(subItem => new MenuItem(subItem));
    this.open = Boolean(item.open);
  }
}
